import * as React from "react";
import RecordGroupsPanel from "../../RecordGroupsPanel";
import "./PropertyGroupsTab.scss";

const PropertyGroupsTab = ({ data, viewMode, ownerAgentId }) => {
  return (
    <div className="Property-groups-tab">
      {ownerAgentId ? (
        <RecordGroupsPanel
          groupType="property"
          memberId={data && data.arcimedes_row_id}
          ownerAgentId={ownerAgentId}
          viewMode={viewMode}
          title="Property Groups"
        />
      ) : null}
    </div>
  );
};

export default PropertyGroupsTab;
